// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import "swiper/css/bundle";
import Swiper from "swiper/bundle";
import lightGallery from "lightgallery";
import lgThumbnail from "lightgallery/plugins/thumbnail";
//--------------------------------------------------------------------//

// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import "./slider-col-text-img.scss";

//--------------------------------------------------------------------//

// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const sliderColTextImg = () => {
    let allSliderColTextImg = document.querySelectorAll(".slider-col-text-img");

    if (!allSliderColTextImg.length) return;

    allSliderColTextImg.forEach((el, i) => {
        let arrowPrev = el.querySelector(".swiper-button-prev");
        let arrowNext = el.querySelector(".swiper-button-next");

        let pagination = el.querySelector(".swiper-pagination");

        let typePagination = "bullets";

        if (pagination) {
            switch (true) {
                case pagination.classList.contains("bullets"):
                    typePagination = "bullets";
                    break;
                case pagination.classList.contains("fraction"):
                    typePagination = "fraction";
                    break;
                case pagination.classList.contains("progressbar"):
                    typePagination = "progressbar";
                    break;
                default:
                    typePagination = "bullets";
                    break;
            }
        }

        let args = {
            slidesPerView: 1,
            spaceBetween: 30,

            navigation: {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },

            pagination: {
                el: pagination,
                dynamicBullets: true,
                clickable: true,
                type: typePagination,
            },
            a11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        };

        const modalSwiper = new Swiper(
            el.querySelector(".swiper-container"),
            args
        );

        let allModalButton = document.querySelectorAll(
            ".archive-list .im-modal__open.grid-item"
        );

        allModalButton.forEach((el, i) => {
            el.addEventListener("click", function (e) {
                e.preventDefault();
                modalSwiper.slideTo(i, 0);
            });
        });

        lightGallery(el.querySelector(".lightgallery"), {
            selector: ".card-col-text-img__img-content",
            thumbnail: true,
            plugins: [lgThumbnail],
            exThumbImage: "data-exthumbimage",
            animateThumb: true,
            mobileSettings: {
                showCloseIcon: true,
            },
            download: false,
            hideBarsDelay: 1000000000,
            autoplayControls: false,
            hash: false,
            escKey: true,
            keyPress: true,
            licenseKey: "WQ63Z-598QW-NZ7D5-WPMTB",
        });
    });
};

export default sliderColTextImg;

//--------------------------------------------------------------------//
